import $ from "jquery";

const redirect = () => {
  const init = () => {
    handleClickAction();
  };

  const handleClickAction = () => {
    $(function () {
      $('.wpcf7.js').find('input').removeAttr('size');
    })
  };

  init();
};

try {
  redirect();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
